module.exports = __webpack_public_path__ + "img/Logo-INRAE.bfbf2463.png";